import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { remainingTopics } from '../data/checks';
export function Offer() {
  return <section id="oferta" className="w-full bg-ink text-white" data-id="element-56" data-mp="1mn95dwlsbkbx">
      <div className="mx-auto w-full max-w-readable px-6 py-16 sm:py-24" data-id="element-57" data-mp="1mmr24g0pg5ui">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.45,
        ease: 'easeOut'
      }} data-id="element-58" data-mp="1hpqqzqp00cwj">
          <p className="text-sm font-semibold uppercase tracking-widest text-white/45" data-id="element-59" data-mp="p1v0j3q0vh87">
            Esto es menos del 5%
          </p>

          <h2 className="mt-4 text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl" data-id="element-60" data-mp="yxetbh9ahzsq">
            Todavía quedan más de 100 configuraciones que revisamos antes de entregar un iPhone
          </h2>

          <ul className="mt-8 grid grid-cols-2 gap-x-6 gap-y-3 sm:grid-cols-3" data-id="element-61" data-mp="2adweumbcmi0l">
            {remainingTopics.map(topic => <li key={topic} className="flex items-center gap-2 text-[15px] text-white/75" data-id="element-62" data-mp="pjp9xxd4gsoc">
                <CheckIcon className="h-4 w-4 shrink-0 text-mint" aria-hidden="true" data-id="element-63" data-mp="ui0im4rokx4z" />
                {topic}
              </li>)}
          </ul>

          <p className="mt-8 text-base leading-relaxed text-white/60" data-id="element-64" data-mp="13jqafbph5y3a">
            …y muchas más. Por eso armé <strong className="font-semibold text-white" data-id="element-65" data-mp="6tzhvi0qul04">iPhone EXPERTO</strong>:
            la guía completa que reúne todo lo que aprendí en 17 años trabajando exclusivamente con
            productos Apple, explicado paso a paso para que aproveches al máximo tu iPhone.
          </p>

          <a href="https://cns.stockdigital.shop" target="_blank" rel="noopener noreferrer" className="mt-10 inline-flex items-center gap-2 rounded-full bg-apple px-7 py-4 text-base font-semibold text-white transition-colors hover:bg-apple-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-ink" data-id="element-66" data-mp="kl4ai05p2d0y">
            Quiero iPhone EXPERTO
            <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-67" data-mp="qgdywl6p2jab" />
          </a>

          <p className="mt-4 text-sm text-white/45" data-id="element-68" data-mp="1548ty886czqk">
            Si esto te sirvió, imaginá lo que podés hacer cuando conozcas las otras 100 configuraciones.
          </p>
        </motion.div>
      </div>
    </section>;
}